import { FC, ReactNode } from 'react';

import { LoadingScreen } from '@app/components/template';
import { useAppSelector } from '@app/hooks/use-store';
import { useGetCommonInitQuery } from '@app/store/api/user.api';
import { route_path } from '@app/utils/route_path';
import { isBoxedMode } from '@app/utils/user-status.utils';

import { LocalizedNavigate } from '../ui';

/**
 * Компонент-обертка для защиты маршрутов в boxed режиме (Sibur).
 * Редиректит авторизованных пользователей на /workspace/text-to-slides/
 * при попытке доступа к публичным страницам.
 */
export const BoxedRouteGuard: FC<{ children: ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading: isAuthCheckLoading } = useAppSelector(
    (state) => state.authState,
  );
  const { data: commonInit, isLoading: isCommonInitLoading } = useGetCommonInitQuery(null);
  const isBoxed = isBoxedMode(commonInit?.result);

  // Пока загружаются данные - показываем loading, чтобы не рендерить children
  if (isCommonInitLoading || isAuthCheckLoading) {
    return <LoadingScreen />;
  }

  // Если boxed режим и пользователь авторизован - редирект на text-to-slides
  if (isBoxed && isAuthenticated) {
    return <LocalizedNavigate to={route_path.textToSlides} replace />;
  }

  return <>{children}</>;
};
